import * as React from 'react';
import { t } from '@moovly/i18n';
import { IconPlus, IconUnlink } from '@moovly/ui';
import { formatDate } from '../../../utils/date';
import { Subscription } from '../types/subscriptions';
import { TableAction, TableCol, TableRow } from '../../../components/Table';

interface SubscriptionsTableRowProps {
  subscription: Subscription;
  onAssign: (sub: Subscription) => void;
  onRevoke: (sub: Subscription) => void;
}
const SubscriptionsTableRow: React.FC<SubscriptionsTableRowProps> = ({ subscription, onAssign, onRevoke }) => {
  const { user } = subscription;
  const assignedTo = React.useMemo(() => {
    if (!subscription.assigned_to) {
      return t('licenseManagement.assignedTo.available');
    }
    if (!!user) {
      return `${user.first_name || ''} ${user.name || ''}  ${!!user.email ? '(' + user.email + ')' : ''}`;
    }
    return null;
  }, [subscription, user]);
  const handleRevoke = React.useCallback(() => {
    onRevoke(subscription);
  }, [onRevoke, subscription]);
  const handleAssign = React.useCallback(() => {
    onAssign(subscription);
  }, [onAssign, subscription]);
  return (
    <TableRow key={`sub-${subscription.id}`}>
      <TableCol>{`${subscription.contract.license_type}${
        !!subscription.contract.reference ? ` (${subscription.contract.reference})` : ''
      }`}</TableCol>
      <TableCol className="email-col">{assignedTo}</TableCol>
      <TableCol>{formatDate(subscription.created_at)}</TableCol>
      <TableCol>{subscription.starts_at && formatDate(subscription.starts_at)}</TableCol>
      <TableCol>{formatDate(subscription.expires_at)}</TableCol>
      <TableCol align="center">{subscription.assignments_left}</TableCol>
      <TableCol>
        {subscription.assigned_to && (
          <TableAction icon={IconUnlink} onClick={handleRevoke} tooltip={t('licenseManagement.revoke')} />
        )}
        {!subscription.assigned_to && subscription.assignments_left > 0 && (
          <TableAction icon={IconPlus} onClick={handleAssign} tooltip={t('licenseManagement.assign')} />
        )}
      </TableCol>
    </TableRow>
  );
};
export default SubscriptionsTableRow;
